import './Keysprint.css'
import { useEffect, useRef } from "react";

// TODO: 
// - make losing focus impossible (disable highlighting for whole page?)
// - listen for all key clicks and releases
// - scoring based on how few keys they pressed
// - time and score attempts
function Keysprint() {
    const typeRef = useRef(null);

    useEffect(() => {
        if (typeRef.current) {
        typeRef.current.focus();
        }
    }, []);

    const handleMouseDown = (event) => {
        event.preventDefault(); // Prevents clicking from changing focus
    };

    const handleBlur = () => {
        requestAnimationFrame(() => {
            if (typeRef.current) typeRef.current.focus();
        });
    };

    return (
        <div className='app-container'>
            <div className='title-container'>
                <h1 className='title'>key<span>sprint</span></h1>
                <p className='splash'>ready your fingers!</p>
            </div>
            <div className='code-container' 
                onMouseDown={handleMouseDown}>
                <div className="type-space"
                    onBlur={handleBlur}
                    contentEditable="true" 
                    suppressContentEditableWarning={true}
                    ref={typeRef} 
                    spellCheck="false"
                >User text here</div>
                <div className="goal-space">function(int age, string name)</div>
            </div>
        </div>
    );
}

export default Keysprint;